var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnsubscribe = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 128.000000 128.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 1137 c-13 -7 -35 -28 -48 -47 l-23 -34 3 -364 3 -364 37 -34 38 -34 291 0 291 0 53 -48 c152 -139 384 -93 476 94 19 40 24 64 24 129 0 92 -21 143 -86 210 l-38 40 -3 197 -3 198 -33 32 -32 33 -463 3 c-357 1 -468 -1 -487 -11z m895 -255 l0 -143 -62 -4 c-159 -10 -278 -129 -288 -287 l-4 -63 -240 -3 -241 -2 0 325 0 325 418 -2 417 -3 0 -143z m35 -294 c64 -33 92 -84 88 -164 -6 -99 -68 -164 -161 -166 -80 -1 -135 29 -167 92 -80 156 83 317 240 238z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242 968 c-29 -14 -39 -55 -21 -85 14 -23 333 -233 354 -233 17 0 337 198 353 218 29 38 0 102 -47 102 -8 0 -77 -39 -154 -87 -77 -47 -145 -86 -151 -86 -6 0 -70 38 -142 85 -147 96 -159 101 -192 86z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M842 490 c-12 -5 -27 -21 -34 -35 -10 -22 -8 -30 9 -53 19 -26 24 -27 126 -30 96 -2 108 -1 127 18 28 28 25 64 -6 89 -23 18 -40 21 -113 20 -47 0 -96 -4 -109 -9z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnsubscribe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unsubscribe.9b03a8deb806e80ec84b70e04b8d7828.svg";